import { BaseModel } from "./base";

export enum ArticuloTransferenciaTipo {
    Envio,
    Recepcion,
}

export type ArticuloTransferencia = BaseModel & {
    fecha: string,
    tipo: ArticuloTransferenciaTipo,
    depositoOrigenId?: string,
    depositoOrigenNombre?: string,
    depositoDestinoId?: string,
    depositoDestinoNombre?: string,
    items: ArticuloTransferenciaItem[]
}

export type ArticuloTransferenciaItem = {
    id: string,
    articuloId: string,
    articuloNombre: string,
    articuloCodigo: string,
    cantidad: number
}